import React, { useState, useEffect } from "react";
import { Button, Modal, Table } from "react-bootstrap";
import _ from "lodash";
import ApiBasketLog from "../../../../../core/api/api.basketLog";

import CloseIcon from "@mui/icons-material/CloseRounded";

function ModalHistoryItem({ show2, data }) {
  const [show, setShow] = useState(show2);
  const [logList, setlogList] = useState([]);
  const handleClose = () => {
    setShow(false);
  };
  useEffect(() => {
    (async () => {
      const dataForShow = {
        BasketId: parseInt(data.BasketId) ? parseInt(data.BasketId) : false,
        BasketItemId: parseInt(data.BasketItemId) ? parseInt(data.BasketItemId) : false,
        BasketPersonId: parseInt(data.BasketPersonId) ? parseInt(data.BasketPersonId) : false,
        BasketItemPersonId: parseInt(data.BasketItemPersonId) ? parseInt(data.BasketItemPersonId) : null,
        PageSize: parseInt(data.PageSize) ? parseInt(data.PageSize) : 100,
      };
      const response = await ApiBasketLog.getBasketLog(dataForShow);
      if (response.succeeded == true) {
        setlogList(response.data);
      }
    })();
    return () => { };
  }, []);

  return (
    <>
      <Modal size="xl" onHide={handleClose} show={show}>
        <Modal.Header closeButton>
          <Modal.Title>تاریخچه تغییرات </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table striped hover responsive="md" bordered={false} borderless={false}>
            <thead className="border">
              <tr className="border">
                <th className="bg-light-primary ">
                  <small className="text-center text-muted"></small>
                </th>
                <th className="bg-light-primary ">
                  <small className="text-center text-muted">نوع فعالیت</small>{" "}
                </th>
                <th className="bg-light-primary ">
                  <small className="text-center text-muted">مقدار</small>
                </th>
                <th className="bg-light-primary ">
                  <small className="text-center text-muted">توسط</small>
                </th>
                <th className="bg-light-primary ">
                  <small className="text-center text-muted">توضیحات</small>
                </th>
                <th className="bg-light-primary  ">
                  <small className="text-center text-muted">تاریخ</small>
                </th>
              </tr>
            </thead>
            <tbody>
              {logList.map((item, index) => (
                <tr key={index}>
                  <td>
                    <small>{index + 1}</small>
                  </td>
                  <td>
                    <small>{item.logTypeS}</small>
                  </td>
                  <td>
                    <small>{item.value}</small>{" "}
                  </td>
                  <td>
                    <small>{item.createdByFullName}</small>
                  </td>
                  <td>
                    <small>{item.description}</small>
                  </td>
                  <td>
                    <small>{item.createdPersianTime}</small>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleClose}>
            <CloseIcon className="mr-1" />
            بستن
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ModalHistoryItem;
